import { TYPES } from "@/components/MessageGeneration/constants";

export default function (type) {
  return type === TYPES.FIRST_MESSAGE;
}
